module.exports = __webpack_public_path__ + "img/746896.24d252e2.jpg";